/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPlaylistX = createReactComponent("outline", "playlist-x", "IconPlaylistX", [["path", { "d": "M19 8h-14", "key": "svg-0" }], ["path", { "d": "M5 12h7", "key": "svg-1" }], ["path", { "d": "M12 16h-7", "key": "svg-2" }], ["path", { "d": "M16 14l4 4", "key": "svg-3" }], ["path", { "d": "M20 14l-4 4", "key": "svg-4" }]]);

export { IconPlaylistX as default };
//# sourceMappingURL=IconPlaylistX.mjs.map
